import { lookbooksService } from "@/services/lookbooks";
import { useQuery } from "@tanstack/react-query";
import { Lookbook } from "@/types/lookbook";
import { ApiMetaParams } from "@/types/api";

export const useLookbooksQuery = (params?: ApiMetaParams) => {
  return useQuery<Lookbook[]>({
    queryKey: ['lookbooks'],
    queryFn: async () => {
      const res = await lookbooksService.getAll(params);
      return res.data;
    },
  });
}
